interface Scripts {
    name: string;
    src: string;
}

export interface QueryParams {
  name: string;
  value: string;
}
export interface Attribute {
  name: string;
  value: string;
}

export const ScriptStore: Scripts[] = [
    { name: 'dropboxChooser', src: 'https://www.dropbox.com/static/api/2/dropins.js'},
    { name: 'googleApi', src: 'https://accounts.google.com/gsi/client' },
    { name: 'googleMaps', src: 'https://maps.googleapis.com/maps/api/js'}
];


const recaptchaScript = document.createElement('script');
const lang = window.localStorage.selectedCulture;
recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=' + lang;
document.head.appendChild(recaptchaScript);



// WEBPACK FOOTER //
// ../UI/src/app/shared/scripts.ts